import {ChevronDownIcon, ChevronUpIcon, FileIcon, XIcon} from '@primer/octicons-react'
import {ActionList, Button} from '@primer/react'
import {useState} from 'react'

import styles from './UploadElement.module.css'

export type UploadState = {
  file: File
  url?: string
}

type UploadFileListProps = {
  uploadStates: UploadState[]
  onRemoveFile: (index: number) => void
}

type UploadFileListItemProps = {
  state: UploadState
  index: number
  onRemoveFile: (index: number) => void
}

function UploadFileListItem({state, index, onRemoveFile}: UploadFileListItemProps) {
  return (
    <ActionList.Item className={styles.listItem}>
      <ActionList.LeadingVisual>
        <FileIcon />
      </ActionList.LeadingVisual>
      {state.url ? (
        <a href={state.url} target="_blank" rel="noreferrer">
          {state.file.name}
        </a>
      ) : (
        <span>{state.file.name} (uploading...)</span>
      )}
      <ActionList.TrailingAction onClick={() => onRemoveFile(index)} label={`Remove ${state.file.name}`} icon={XIcon} />
    </ActionList.Item>
  )
}

export function UploadFileList({uploadStates, onRemoveFile}: UploadFileListProps) {
  const [showAllFiles, setShowAllFiles] = useState(false)

  if (uploadStates.length === 0) {
    return null
  }

  const hasMoreThanThreeFiles = uploadStates.length > 3

  return (
    <>
      <ActionList className={styles.list}>
        {uploadStates.slice(0, 3).map((state, index) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <UploadFileListItem key={index} state={state} index={index} onRemoveFile={onRemoveFile} />
        ))}
      </ActionList>
      {hasMoreThanThreeFiles && (
        <Button
          variant="invisible"
          onClick={() => setShowAllFiles(!showAllFiles)}
          trailingVisual={showAllFiles ? ChevronUpIcon : ChevronDownIcon}
          className={styles.toggleButton}
        >
          {showAllFiles ? 'View less' : `View ${uploadStates.length - 3} more`}
        </Button>
      )}
      {hasMoreThanThreeFiles && showAllFiles && (
        <ActionList className={styles.list}>
          {uploadStates.slice(3).map((state, idx) => {
            const index = idx + 3
            return <UploadFileListItem key={index} state={state} index={index} onRemoveFile={onRemoveFile} />
          })}
        </ActionList>
      )}
    </>
  )
}
